(function () {
  'use strict';

  function init(section) {
    if (!section) return;
    var tabs = Array.from(section.querySelectorAll('.evry-sl-tab'));
    var groups = section.querySelectorAll('.evry-sl-region-group');

    if (!tabs.length) return;

    function activateTab(tab) {
      var region = tab.dataset.region;

      tabs.forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
      tab.focus();

      groups.forEach(function (group) {
        if (region === 'all' || group.dataset.region === region) {
          group.classList.remove('hidden');
        } else {
          group.classList.add('hidden');
        }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.setAttribute('tabindex', i === 0 ? '0' : '-1');

      tab.addEventListener('click', function () {
        activateTab(this);
      });

      tab.addEventListener('keydown', function (e) {
        var idx = tabs.indexOf(this);
        var next;

        switch (e.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();
            next = idx + 1 >= tabs.length ? 0 : idx + 1;
            activateTab(tabs[next]);
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();
            next = idx - 1 < 0 ? tabs.length - 1 : idx - 1;
            activateTab(tabs[next]);
            break;
          case 'Home':
            e.preventDefault();
            activateTab(tabs[0]);
            break;
          case 'End':
            e.preventDefault();
            activateTab(tabs[tabs.length - 1]);
            break;
        }
      });
    });
  }

  document.querySelectorAll('.evry-store-locator').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.evry-store-locator');
    if (section) init(section);
  });
})();
